
export const initialSolutions = [
    {
        id: 1,
        name: 'Tanga Dashboard',
        url: '',
        description: 'Plateforme de gestion et tableau de bord de Tanga Africa.',
        category: 'Gestion',
    },
    {
        id: 2,
        name: 'Soins esthétiques',
        url: '',
        description: 'Soin esthétique.',
        category: 'Métier',
    },
    {
        id: 3,
        name: 'bakery_management_system',
        url: '',
        description: 'Gestion de boulangerie.',
        category: 'Métier',
    },
];

export function getSavedSolutions() {
    const saved = localStorage.getItem('tanga-solutions');

    if (!saved) {
        return initialSolutions;
    }

    try {
        const parsed = JSON.parse(saved);

        return Array.isArray(parsed) ? parsed : initialSolutions;
    } catch {
        return initialSolutions;
    }
}
